<template>
<div>
  <HomeAltLayout isHome="true" bg_icon='fyiio'>
    <FyiioSvgLogo showTitle="" />
    <br>
    <div class="row register-form smallzer">
        <div class="center col s12 m4 offset-m6">
               <div style="color:white;font-size:36px;font-weight:400;padding: 5px 5px 25px 25px" class="valign">It happens.</div>
          </div>
    </div>
    <br>
    <form @submit.prevent="passwordReset" >
      <div class="row register-form smallzer">
          <div class="center col s10 offset-s1 m4 offset-m6">
                
                  <div class="alert alert-danger" v-if="error">
                    <p v-if="error" class="error">{{ error.message }}</p>
                  </div>
                  
          </div>
      </div> 
      <div class="row register-form smallzer">
          <div class="center col s10 offset-s1 m4 offset-m6 " style="background-color:white;border-radius:5px">
            <div class="input-field" style="height:30px">
              <input id=fullname_inline type="text" v-model="username" autocomplete="off" required style="background:white;border-bottom: 0px solid orange;-webkit-box-shadow: 0 0px 0 0 orange;-moz-box-shadow: 0 0px 0 0 orange;box-shadow: 0 0px 0 0 orange;">
              <label for="fullname_inline">Email Address</label>
            </div>
          </div>
      </div>
      <div class="row register-form smallzer">
        <div class="col s12 offset-m6 m4 " :class="$mq === 'md'?'left':'center'">
          <button class="btn blue" :style="$mq === 'md'?'position:relative; left:-10px':''" style="border-radius:20px;text-transform:none">Continue</button>
        </div>
      </div>
      <div class="row register-form smallzer">
        <div class="col s12 m4 offset-m6 center"  >
          <p class="" style="color:white">
            Suddenly remember your password? <a href="/login">Log in.</a>
          </p>
        </div>
      </div>
                  
    </form>
     
          
      
  </HomeAltLayout>
  
</div>
</template>

<script>
import HomeAltLayout from '@/containers/layouts/HomeAltLayout'
import FyiioSvgLogo from '@/components/FyiioSvgLogo'
export default {
  data () {
    return {
      username: this.$route.query.username || '',
      error: null
    }
  },
  mounted(){
    $('#bigz').removeClass('blue-bg').addClass('fish-bg');
  },
  methods: {
    passwordReset () {
      this.$cognitoAuth.forgotPassword(this.username, (err, result) => {
        if (err) {
          this.error = err
          console.error(err)
        } else {
          this.$router.replace({path: '/confirm_reset_password', query: {username:   this.username} })
        }
      })
    }
  },
  components: {
    HomeAltLayout,
    FyiioSvgLogo
  }
}
</script>

<style scoped>
.error {
  color: red;
}
.mobileLayout {
  background-image: url('./../../assets/galaxy.png');
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/containers/authentication/PasswordResetAlt.vue